<div class="modal" style="display: block;" role="dialog"  data-bs-backdrop = 'static' data-backdrop="static"  backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
<div class="modal-backdrop show"></div>
